import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectListItems } from "../../../../../redux/library/selector";
import { selectEventsListItems } from "../../../../../redux/event/events/selector";
import { events } from "../../../../../redux/event/events/action";
import PageLoader from "../../../../../components/PageLoader";

const MyEvents = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [pageData, setPageData] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const libraryData = useSelector(selectListItems);
  const eventsItemsData = useSelector(selectEventsListItems);
  const [columnDefs, setColumnDefs] = useState({});

  const fetchEventsList = () => {
    dispatch(events.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/events/list`,
      entity: 'events',
      jsonData: {

        "Context": {
          "Subscription": "ONE",
          "Domain": "ONE",
          "SubDomains": [],
          "Network": "ONEUser",
          "Application": "ONEUser",
          "Channel": "CSP"
        },
        "Records": [
          {
            "Id": 0
          }
        ],
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc"
      }
    }));
  };

  useEffect(() => {
    fetchEventsList();
  }, [pageData, pageSize]);


  const handleAdd = () => {
    navigate(`${0}`);
  };

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }
  const handleReloadData = () => {
    fetchEventsList()
  }
  const additionButtons: any = [

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];


  return (
    <>
      {eventsItemsData?.isLoading ? (
        <PageLoader />
      ) : (
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex justify-end mb-4 pr-7">
            {additionButtons.map((btn: any, index: number) => (
              <button
                key={index}
                onClick={btn.callback}
                className="p-2 border rounded-md bg-black text-white hover:bg-gray-800"
                title="Reload"
              >
                {btn.svg}
              </button>

            ))}
          </div>

          <div className="space-y-6">
            {eventsItemsData?.result?.items?.map((item: any) => (
              <div
                key={item.Id}
                className="flex flex-col sm:flex-row items-start bg-indigo-50 border border-indigo-200 shadow rounded-2xl p-6 hover:shadow-md transition duration-200"
              >
                <img
                  src={item?.MediaMappings?.MediaFiles?.[0]?.FileMappingURL}

                  alt={item.Name}
                  className="w-32 h-32 rounded-lg object-cover mr-0 sm:mr-6 mb-4 sm:mb-0"
                />

                <div className="flex-1 space-y-2">
                  <button
                    onClick={() => handleEdit(item)}
                    className="text-2xl font-bold text-indigo-800 hover:underline"
                  >
                    {item.Name}
                  </button>

                  <p className="text-base text-gray-700">{item.Description}</p>

                  <div className="text-sm text-gray-600 mt-2 flex flex-wrap gap-x-10 gap-y-2">

                    <span>
                      <strong>IsActive:</strong>{' '}
                      {item.IsActive ? 'Yes' : 'No'}
                    </span>
                    <span>
                      <strong>IsEnable:</strong> {item.IsEnable}
                      {item.IsActive ? 'Yes' : 'No'}
                    </span>


                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default MyEvents;
